import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { useStyles } from './index.style';
import styles from './OptionsBoardStyles';

const AdvancedBoardStrikeNear = ({
  isMobile,
  toggleShading,
  isChecked,
  strikeWidth,
}) => {
  const classes = useStyles();

  return (
    <div
      className="sticky"
      style={
        isMobile
          ? styles.basicBoardsWrappeInput
          : {
              ...styles.strikeOB,
              maxWidth: window.innerWidth > 2200 ? '' : '740px',
              width: window.innerWidth > 2200 ? strikeWidth : '',
            }
      }
    >
      <div
        style={
          isMobile
            ? { display: 'none', width: '50%' }
            : {
                display: 'flex',
                justifyContent: 'end',
                paddingRight: '10px',
                position: 'absolute',
                right: 0,
              }
        }
      >
        <div style={styles.spaan}>Shade</div>{' '}
        <Checkbox
          checked={!isChecked}
          onClick={toggleShading}
          classes={{ root: classes.root }}
        />
      </div>
    </div>
  );
};

export default AdvancedBoardStrikeNear;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/AdvancedBoardStrikeNear.jsx